import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomCKEditor from "ckeditor5-norsys-custom-balloon-block-build";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Button } from "reactstrap";
import Swal from "sweetalert2";
import { TrainingPathTanslationDto } from "../../../../models/trainingPathTranslationDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import Breadcrumbs from "../../../../shared/breadcrumb/breadCrumb";
import { translate } from "react-switch-lang";
import CKEditorUploadAdapter from "./CKEditorUploadAdapter";
import "./trainingPathEditor.scss";

const editorCustomConfig = {
  config: { width: "10%" },
  toolbar: {
    items: ["italic", "bold", "underline", "|", "blockQuote", "code", "link", "fontFamily", "fontSize", "fontColor", "fontBackgroundColor", "removeFormat"],
    shouldNotGroupWhenFull: true,
  },
  image: {
    toolbar: ["imageTextAlternative", "imageStyle:inline", "imageStyle:alignLeft", "imageStyle:alightRight", "imageStyle:block", "imageStyle:side", "linkImage"],
  },
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableCellProperties", "tableProperties"],
  },
  blockToolbar: ["heading", "|", "outdent", "indent", "alignment", "|", "bulletedList", "numberedList", "todoList", "|", "insertTable", "imageUpload", "mediaEmbed", "|", "undo", "redo"],
  extraPlugins: [CustomCKEditorUploadAdapterPlugin],
};

let editorDataFromServer: string;

// const inittemplate: string =
//   '<h4 style="margin-left:auto;text-align:center;">&nbsp;</h4><h4 style="margin-left:auto;text-align:center;"><span style="color:hsl(30,75%,60%);font-size: 1.5em">Vous intervernez en appui au secteur agricole ?</span></h4><p style="margin-left:auto;text-align:center;"><span class="text-big" style="font-size: 1.8em">Que vous soyez chef de projet, coordinateur, chef de service, responsable animation territoriale... cette formation est faites pour vous !</span></p><p style="margin-left:auto;text-align:center;">&nbsp;</p><h4 style="margin-left:auto;text-align:center;"><span style="color:hsl(30,75%,60%);font-size: 1.5em">Vous devez accompagner la transition agro-écologique d\'un territoire ?</span></h4><p style="margin-left:auto;text-align:center;"><span class="text-big" style="font-size: 1.8em">Cette formation en ligne vous permettra de découvrir les méthodes et outils pour identifier les actions multi-acteurs / pluri-secteurs qui favorisent et sécurisent la transition agro-écologique et mettre en oeuvre ces actions.</span></p>';

const TrainingPathEditor: React.FC<{
  t: (key: string) => string;
}> = props => {
  const httpClient = useHttpClient();
  const [editorData, setEditorData] = useState("");
  const [editorDataToUpdate, setEditorDataToUpdate] = useState("");
  const [dataToAdd, setDataToAdd] = useState("");
  const params = useParams<{ id: string }>();
  const history = useHistory();

  useEffect(() => {
    async function getTemplate() {
      const existingTemplateResponse = await httpClient.current?.get<any>(`/trainingPathTranslation/${params.id}/template`);
      const traninginPathTranslation = await httpClient.current?.get<TrainingPathTanslationDto>(`/trainingPathTranslation/${params.id}`);
      setEditorData(existingTemplateResponse.data && existingTemplateResponse.data !== "" ? existingTemplateResponse.data : "<p> Insert your text here </p>");
      setEditorDataToUpdate(traninginPathTranslation.data.addedTemplateText && traninginPathTranslation.data.addedTemplateText !== "" ? traninginPathTranslation.data.addedTemplateText : "");
    }
    getTemplate();

    // eslint-disable-next-line
  }, []);

  const onChangeDataHandler = (event, editor) => {
    setDataToAdd(editor.getData());
  };

  const onSubmitDataHandler = () => {
    Swal.fire({
      title: "Voulez-vous enregistrer les modifications ?",
      confirmButtonText: "Enregistrer",
      cancelButtonText: props.t("cancel"),
      showCancelButton: true,
      icon: "warning",
    }).then(result => {
      if (result.isConfirmed) {
        const config = { headers: { "Content-Type": "application/json" } };
        httpClient.current?.put(`/trainingPathTranslation/${params.id}/template`, dataToAdd, config).then(() => history.goBack());
      }
    });
  };

  const onDiscardChangesHandler = () => {
    if (editorData !== editorDataFromServer) {
      Swal.fire({
        title: "Voulez-vous annuler les modifications ?",
        text: "Vous avez des modifications non enregistrées si vous quittez vos modifications seront perdues",
        confirmButtonText: "Quitter cette page",
        cancelButtonText: "Restez sur cette page",
        showCancelButton: true,
        icon: "warning",
      }).then(result => {
        if (result.isConfirmed) {
          history.goBack();
        }
      });
    } else {
    }
  };

  return (
    <>
      <Breadcrumbs parent={props.t("training_path_list")} title={props.t("modify_course_presentation_page")} />
      <div className="editor-container">
        <CKEditor editor={CustomCKEditor} data={editorData} disabled />
        <CKEditor editor={CustomCKEditor} config={editorCustomConfig} data={editorDataToUpdate} onChange={onChangeDataHandler} />
        <div className="ckeditor-actions">
          <Button outline color="success" disabled={editorDataFromServer === editorData} onClick={onSubmitDataHandler}>
            Enregister
          </Button>
          <Button outline color="primary" className="ckeditor-cancel-button" onClick={onDiscardChangesHandler}>
            {props.t("cancel")}
          </Button>
        </div>
      </div>
    </>
  );
};

function CustomCKEditorUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => {
    return new CKEditorUploadAdapter(loader);
  };
}

export default translate(TrainingPathEditor);
